import React, {Component} from 'react';
import {Button, Card, CardBody, CardTitle} from 'reactstrap';
import ResultCard from './ResultCard.js';

class PropFinder extends Component {

	componentDidMount(prevProps, prevState) {
		let input = document.getElementById('fuzzyFormInput');
		input.focus();
	}

	render() {
		let results = [];

		if (
			this.props.isBetterArray(this.props.searchResults) &&
      this.props.searchResults.length > 0
		) {
			results = this.props.searchResults.map((result, i) => {
				return (
					<ResultCard
						result={result}
						num={i + 1}
						key={`search-result-${i}`}
						handleGetRouteFromSearch={this.props.handleGetRouteFromSearch}
					/>
				);
			});
		}

		return (
			<div className="propfinder">
				<Card>
					<CardBody>
						<CardTitle>Search by Property Name, Number, or Alias</CardTitle>
						<form id="fuzzyForm" onSubmit={this.props.handleGetFuzzy}>
							<div>
								<input
									id="fuzzyFormInput"
									autoFocus="true"
									type="text"
									value={this.props.fuzzyFindValue}
									onChange={this.props.handleFuzzyChange}
								/>
								<Button color="success">Search</Button>
							</div>
						</form>
						<h3 className="resultsFound">{results.length > 0 ? `${results.length} Records Found:` : ''}</h3>
						{results}
					</CardBody>
				</Card>
			</div>
		);
	}
}

export default PropFinder;



// WEBPACK FOOTER //
// ./src/components/PropFinder.js